import { openDB } from 'idb';
import { SIP } from '../models/sip';

const dbPromise = openDB('sip-db', 1, {
  upgrade(db) {
    db.createObjectStore('sip', { keyPath: 'id', autoIncrement: true });
  },
});

export const saveSIP = async ({
  monthlyInvestment,
  rate,
  period,
  totalAmount,
  interestEarned,
  currencySymbol,
  title
}: SIP & { currencySymbol: string }): Promise<void> => {
  const db = await dbPromise;
  await db.add('sip', { 
    title, 
    monthlyInvestment,
    rate,
    period,
    totalAmount,
    interestEarned,
    currencySymbol,
  });
};

export const fetchSIPs = async (): Promise<SIP[]> => {
  const db = await dbPromise;
  const allSIPs: SIP[] = await db.getAll('sip');  
  return allSIPs;
};

export const updateSIP = async (
  id: number,
  updatedData: Omit<SIP, 'id'>
): Promise<void> => {
  const db = await dbPromise;
  await db.put('sip', { id, ...updatedData });  
};

export const deleteSIP = async (id: number): Promise<void> => {
  const db = await dbPromise;
  await db.delete('sip', id);  
};
